import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-treino-itens-modal',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './treino-itens-modal.component.html'
})
export class TreinoItensModalComponent {

  @Input() config: any;
  @Input() tipo: 'exercicio' | 'abdominal' | 'cardio' = 'exercicio';

  @Output() salvar = new EventEmitter<any[]>();

  form!: FormGroup;

  grupos: { key: string, value: any[] }[] = [];

  tiposExercicio = [
    { id: 1, nome: 'Perna' },
    { id: 2, nome: 'Bíceps' },
    { id: 3, nome: 'Tríceps' },
    { id: 4, nome: 'Peito' },
    { id: 5, nome: 'Costas' },
    { id: 6, nome: 'Ombro' }
  ];

  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit() {
    this.form = this.fb.group({
      itens: this.fb.array([])
    });

    this.buildForm();
    this.buildGrupos();
  }

  cancelar() {
    this.activeModal.dismiss('cancel');
  }

  get itensFA(): FormArray {
    return this.form.get('itens') as FormArray;
  }

  trackById(index: number, item: any) {
    return item?.ctrl?.value?.id ?? item?.id ?? index;
  }

  getTipoNome(tipoId: number): string {
    return this.tiposExercicio.find(t => t.id === tipoId)?.nome ?? 'Outros';
  }

  private buildGrupos() {
    const gruposMap: { [key: string]: any[] } = {};

    this.itensFA.controls.forEach((ctrl: any, index: number) => {
      const tipoId = ctrl.value.tipo ?? 0;
      const tipoNome = this.getTipoNome(tipoId);

      if (!gruposMap[tipoNome]) {
        gruposMap[tipoNome] = [];
      }

      gruposMap[tipoNome].push({ ctrl, index });
    });

    this.grupos = Object.keys(gruposMap).map(key => ({
      key,
      value: gruposMap[key]
    }));
  }

  // 🔥 NOVO: contador por grupo (SEM recriar DOM)
  countSelecionados(grupo: any[]): number {
    let count = 0;

    grupo.forEach(item => {
      if (this.getSelecionado(item.index).value) {
        count++;
      }
    });

    return count;
  }

  // =========================
  // GETTERS
  // =========================

  getSelecionado(i: number): FormControl {
    return this.itensFA.at(i).get('selecionado') as FormControl;
  }

  getOrdem(i: number): FormControl {
    return this.itensFA.at(i).get('ordem') as FormControl;
  }

  getSeries(i: number): FormControl {
    return this.itensFA.at(i).get('series') as FormControl;
  }

  getRepeticoes(i: number): FormControl {
    return this.itensFA.at(i).get('repeticoes') as FormControl;
  }

  getCarga(i: number): FormControl {
    return this.itensFA.at(i).get('cargaInicial') as FormControl;
  }

  private buildForm() {

    let todos: any[] = [];
    let selecionados: any[] = [];

    if (this.tipo === 'exercicio') {
      todos = this.config?.todosExercicios ?? [];
      selecionados = this.config?.selecionadosExercicios ?? [];
    }

    if (this.tipo === 'abdominal') {
      todos = this.config?.todosAbdominais ?? [];
      selecionados = this.config?.selecionadosAbdominais ?? [];
    }

    if (this.tipo === 'cardio') {
      todos = this.config?.todosCardios ?? [];
      selecionados = this.config?.selecionadosCardios ?? [];
    }

    todos.forEach((item: any) => {

      const sel = selecionados.find((x: any) =>
        x.exercicioId === item.id ||
        x.abdominalId === item.id ||
        x.cardioMetaId === item.id
      );

      this.itensFA.push(
        this.fb.group({
          id: new FormControl(item.id),
          nome: new FormControl(item.nome),
          tipo: new FormControl(item.tipo ?? 0),

          selecionado: new FormControl(!!sel),
          ordem: new FormControl(sel?.ordem ?? 0),
          series: new FormControl(sel?.series ?? 0),
          repeticoes: new FormControl(sel?.repeticoes ?? 0),
          cargaInicial: new FormControl(sel?.cargaInicial ?? 0)
        })
      );
    });
  }

  submit() {

    const result = this.itensFA.value
      .filter((x: any) => x.selecionado)
      .map((x: any) => {

        if (this.tipo === 'exercicio') {
          return {
            exercicioId: x.id,
            ordem: x.ordem,
            series: x.series,
            repeticoes: x.repeticoes,
            cargaInicial: x.cargaInicial
          };
        }

        if (this.tipo === 'abdominal') {
          return {
            abdominalId: x.id,
            ordem: x.ordem,
            series: x.series,
            repeticoes: x.repeticoes
          };
        }

        return {
          cardioMetaId: x.id,
          ordem: x.ordem
        };
      });

    this.activeModal.close(result);
  }
}